module.exports = __webpack_public_path__ + "static/img/honor26.22c21ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor26.png
// module id = 7D5m
// module chunks = 0